module.exports = __webpack_public_path__ + "img/svg/banner-card.7d45cbec2cbb03b121a2c605ac3ee5fc.svg";